import * as styles from './Header.module.css'

function Header({ children, className = styles.Header }) {
  return (
    <header className={className} data-section='HeaderSection'>
      {children}
    </header>
  )
}

export default Header
